export const EPOCH_DATE = new Date(1970, 0, 1, 0, 0, 0, 0);
export const DEFAULT_LOCATION = { name: "", distance: 0 };
export const DEFAULT_DISTANCE = 50;
export const FILTERS = ["date", "nights", "price", "region_ids", "rounds"];

export const SORT_CLOSEST = "closest";
export const SORT_MOST_POPULAR = "most-popular";
const PRICE_SORT_OPTIONS = [
  {
    value: "price-asc",
    label: "Price (Low to High)",
  },
  {
    value: "price-desc",
    label: "Price (High to Low)",
  },
];
export const DEFAULT_SORT_OPTIONS = [
  {
    value: SORT_MOST_POPULAR,
    label: "Most Popular",
  },
  ...PRICE_SORT_OPTIONS,
];
export const LOCATION_SORT_OPTIONS = [
  {
    value: SORT_CLOSEST,
    label: "Closest First",
  },
  ...PRICE_SORT_OPTIONS,
];

export const UNLIMITED_VALUE = 999;
